export { Fair as FairIcon } from './rating/Fair';
export { Fantastic as FantasticIcon } from './rating/Fantastic';
export { Good as GoodIcon } from './rating/Good';
export { Poor as PoorIcon } from './rating/Poor';
export { VeryPoor as VeryPoorIcon } from './rating/VeryPoor';

export { Empty as EmptyIcon } from './Empty';
